<div class="modal-backdrop fade in"></div>
<small id="modal-title" class="sr-only">{{ config.data.title }}</small>
<div class="modal fade in scroll" role="dialog" aria-modal="true" aria-labelledby="modal-title" appFocusTrap
  style="display: block" [ngStyle]="{
    'width': config.data.style?.width || 'auto',
    'height': config.data.style?.height || 'auto',
    'z-index': config.data.style?.zIndex || '1050'
  }" #modalContainer>
  <div class="modal-dialog" role="document" (click)="onDialogClicked($event)">
    <div class="modal-content">
      <div class="col-sm-2 col-sm-offset-10" style="padding: 0;">
        <button class="btn btn-default-reverse btn-block btn-sm close-button" type="button" (click)="close()">
          Chiudi
        </button>
      </div>
      <div class="titleblock" *ngIf="config.data.title">
        <h3 class="title1level" id="modalTitle">{{ config.data.title }}</h3>
      </div>
      <div [ngClass]="{ scroll: config.data.style.overflow }" class="container_dati_generali">
        <ng-template appInsertion></ng-template>
      </div>
    </div>
  </div>
</div>